/**
 * Vega-Lite specs for the chart components in this folder. The specs own
 * their tooltip and axis words (`CHART_LABELS`); palette and data types live
 * in `@/lib/utils/vega-chart-shared`.
 */

// Chart tooltip and axis labels
export const T = {
  en_GB: {
    category: "Category",
    percentage: "Percentage",
    date: "Date",
    value: "Value",
    period: "Period",
    expected: "Expected",
    upperBound: "Upper (95%)",
    lowerBound: "Lower (5%)",
    savingPlan: "Your saving plan",
    bankSavings: "Saving in bank account",
  },
  nb_NO: {
    category: "Kategori",
    percentage: "Prosent",
    date: "Dato",
    value: "Verdi",
    period: "Periode",
    expected: "Forventet",
    upperBound: "Øvre (95%)",
    lowerBound: "Nedre (5%)",
    savingPlan: "Din spareplan",
    bankSavings: "Sparing på bankkonto",
  },
} as const;
